import { Component, OnInit } from '@angular/core';
import { AuthService } from '../_services/auth.service';
import { User } from '../models/user.model';
import { RoleService } from '../_services/role.service';
import { Role } from '../models/role.model';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  form: any = {};
  isSuccessful = false;
  isSignUpFailed = false;
  errorMessage = '';
  user: User;
  items = ["admin", "mod", "user"];
  selected :any;


  constructor(private authService: AuthService,
              private roleService: RoleService) { }

  ngOnInit() {
    /*const set1 = new Set(["admin", "mod", "user"]);
    console.log(set1);*/
    //this.loadSelectRole();
    this.user = new User();
  }
  /*loadSelectRole(){
    this.roleService.getAll().subscribe(
      (data: Role[]) => {
        this.items = data;
        console.log(this.items);
      },
    );
  }*/
  getValues() {
    console.log("Select roles", this.form.role);

  }

  onSubmit() {
     //this.form.roles = this.s;
    //this.user = this.form;
    //this.user.roles = this.form.roles;
    console.log("Form", this.form);
    this.authService.register(this.form).subscribe(
      data => {
        console.log(data);
        this.isSuccessful = true;
        this.isSignUpFailed = false;
      },
      err => {
        this.errorMessage = err.error.message;
        this.isSignUpFailed = true;
      }
    );
  }
}
